// ProfileWrapper.jsx
import { useTheme, useMediaQuery } from '@mui/material';
import MyAccount from 'pages/my-account/MyAccount';
import ProfilePage from 'pages/profile/Profile';

const ProfileWrapper = () => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

    return isLargeScreen ? <MyAccount /> : <ProfilePage />;
};

export default ProfileWrapper;